import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pinpoint/design-kit';
import DeleteClientDialog from 'src/components/dialogs/deleteClient';
import CONSTANTS from 'src/store/constants';
import Rbac from './rbac';

export function DeleteClient({ iconSize = '1rem', tenant, onDelete }) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const openModal = () => setShowConfirmModal(true);
  const closeModal = () => setShowConfirmModal(false);
  const handleDelete = () => onDelete(tenant);
  return (
    <Rbac
      roles={[CONSTANTS.ROLE.SUPER_ADMIN]}
      fallback={
        <Icon
          size={iconSize}
          viewBox="0 0 50 50"
          color="tabRest"
          name="Delete"
          cursor="not-allowed"
          m={{ x: '0.3125rem' }}
        />
      }
    >
      <Icon
        size={iconSize}
        color="tabSelected"
        hoverColor="danger800"
        viewBox="0 0 50 50"
        name="Delete"
        cursor="pointer"
        data-tip="Delete client"
        hoverTransform="scale(1.25)"
        m={{ x: '0.3125rem' }}
        onClick={openModal}
      />
      <DeleteClientDialog
        isOpen={showConfirmModal}
        actions={{
          close: {
            on: closeModal,
          },
          cancel: {
            on: () => {},
          },
          handlers: [
            {
              on: handleDelete,
            },
          ],
        }}
      />
    </Rbac>
  );
}

/* eslint-disable react/require-default-props */
DeleteClient.propTypes = {
  iconSize: PropTypes.string.isRequired,
  tenant: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};
/* eslint-enable */

export default DeleteClient;
